import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
});

export const getStoredToken = () => {
	const raw = localStorage.getItem("token");
	if (!raw) return null;
	try { return JSON.parse(raw); } catch { return raw; }
};

let refreshPromise;
export const refreshSession = () => {
	if (!refreshPromise) {
		refreshPromise = api.post("/auth/refresh_token").then(({ data }) => {
			localStorage.setItem("token", JSON.stringify(data.token));
			localStorage.setItem("user", JSON.stringify(data.user));
			api.defaults.headers.Authorization = `Bearer ${data.token}`;
			return data;
		}).finally(() => { refreshPromise = null; });
	}
	return refreshPromise;
};

api.interceptors.request.use(config => {
	config.baseURL = getBackendUrl();
	const token = getStoredToken();
	if (token) config.headers.Authorization = `Bearer ${token}`;
	else delete config.headers.Authorization;
	return config;
});

api.interceptors.response.use(response => response, async error => {
	const request = error.config;
	const message = error.response?.data?.error || error.response?.data?.message;
	const expired = error.response?.status === 403 &&
		message === "Invalid token. We'll try to assign a new one on next request";
	if (expired && request && !request._retry && !request.url?.includes("/auth/")) {
		request._retry = true;
		try {
			await refreshSession();
			return api(request);
		} catch (refreshError) {
			return Promise.reject(refreshError);
		}
	}
	if (error.response?.status === 401 && !request?.url?.includes("/auth/login")) {
		localStorage.removeItem("token");
		delete api.defaults.headers.Authorization;
		window.dispatchEvent(new Event("auth:expired"));
	}
	return Promise.reject(error);
});

export default api;
